import React, { useEffect, useState } from "react";
import Statistics from "../Statistics/Statistics";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  InputGroup,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import LatestActivities from "views/Admin/user-management/LatestActivities";
import BreadCrumbs from "components/shared/BreadCrumbs";
import EntityTable from "components/shared/EntityTable";
import {
  personNameColumn,
  emailColumn,
  phoneColumn,
  statusColumn,
} from "components/shared/entityColumns";
import { useTranslation } from "react-i18next";
import { CiEdit } from "react-icons/ci";
import {
  getClassDetail,
  getClassTeachersAndStudents,
} from "services/Teacher/ClassesAndGroups.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageHeading from "components/shared/PageHeading";
import { getAllTimeStamps } from "services/Teacher/TimeStamp.service";
import moment from "moment";
import nodataimage from "../../../assets/nodataimage.svg";
import {
  deleteAssignments,
  getSpecificSubmissions,
} from "services/Teacher/Assignments.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faFile,
  faPlus,
  faSearch,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import AddStudentModal from "components/modals/AddStudentModal";
import { toast } from "react-toastify";
import { deleteStudent } from "services/Admin/UserManagement/School.service";
import ImportSheetModal from "components/modals/ImportSheetModal";
import SummaryModal from "components/modals/SummaryModal";
import { UpdateStudentStatus } from "services/Teacher/User.service";
import dropdown from "../../../assets/dropdown.svg";
import AddGroupStudentsModal from "components/modals/AddGroupStudentsModal";
import DeleteAssignmentModal from "components/modals/DeleteTeacherAssignmentModal";
import { getClassStats } from "services/Student/UserInfo.services";
import CustomPagination from "components/shared/Pagination";
import Skeleton from "react-loading-skeleton";
import { getAllSubject } from "services/Teacher/Exercise.service";
import AddClassTeacherModal from "components/modals/AddClassTeacherModal";
import { editClassName } from "services/Teacher/ClassesAndGroups.service";

const sortOptions = ["A to Z", "Z to A", "Latest", "Oldest"]

const ClassesAndGroupDetailPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [classData, setClassData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exercises, setExercise] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showTeacherModal, setShowTeacherModal] = useState(false);
  const [showImportSheetModal, setShowImportSheetModal] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [loadingstats, setLoadingStats] = useState(true)
  const [statsData, setStatsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(4);
  const [loadingTimeStamp, setLoadingTimeStamp] = useState(true)
  const [currentPageTable, setCurrentPageTable] = useState(1);
  const [totalPagesTable, setTotalPagesTable] = useState(1);
  const [limitTable, setLimitTable] = useState(5);
  const [currentPageStudents, setCurrentPageStudents] = useState(1);
  const [totalPagesStudents, setTotalPagesStudents] = useState(1);
  const [limitStudents, setLimitStudents] = useState(4);
  const [currentPageTeacher, setCurrentPageTeacher] = useState(1);
  const [totalPageTeacher, setTotalPageTeacher] = useState(1);
  const [limitTeacher, setLimitTeacher] = useState(4);
  const [loadingStudents, setLoadingStudents] = useState(false)
  const [loadingTeacher, setLoadingTeacher] = useState(false)
  const [classNameField, setClassNameField] = useState(false)
  const [classNameInput, setClassNameInput] = useState("")

  const [selectedSubject, setSelectedSubject] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSort, setSelectedSort] = useState(null);
  const [search, setSearch] = useState("");

  const handleCloseModal = () => {
    setShowGroupModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleTeacherClose = () => {
    setShowTeacherModal(false);
  };

  const handleOpenImportSheetModal = () => setShowImportSheetModal(true);

  const handleCloseImportSheetModal = () => {
    setShowImportSheetModal(false);
  };

  useEffect(() => {
    // console.log("Summary data updated:", summaryData);
  }, [summaryData]);

  const handleShowSummaryModal = () => {
    setShowSummaryModal(true);
  };

  const handleCloseSummaryModal = () => {
    setShowSummaryModal(false);
    setSummaryData(null);
  };

  const handleShowDeleteModal = (id) => {
    setPendingStatusChange({ id, newStatus: "deleted" });
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const toggleClassName = () => {
    setClassNameField(!classNameField)
  }
  const handleClassNameChange = async () => {
    try {
      const response = await editClassName(params.id, { title: classNameInput })
      if (response.status === 200) {
        setClassNameField(!classNameField)
        toast.success("Class Name updated successfully!");
        fetchClass();
      }

    } catch (error) {
      console.log("error", error);

      toast.update({
        render: `Error: ${error.response.data.error || "Class Name update failed"}`,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      });
    }
  }

  const handleDeleteExercise = async (id) => {
    const toastId = toast.loading("Deleting exercise...");
    try {
      await deleteAssignments(id);
      fetchAssignments();
      toast.update(toastId, {
        render: "Assignment deleted successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Error deleting exercise",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
      console.error("Error deleting exercise:", error);
    } finally {
      setShowDeleteModal(false);
      setPendingStatusChange(null);
    }
  };

  // Point the crumb back at whichever list the user came from.
  const isGroupRoute = location.pathname.startsWith("/groups");
  const breadcrumbItems = [
    isGroupRoute
      ? { label: "Groups", href: "/groups" }
      : { label: "Classes", href: "/classes" },
    loading || !classData
      ? { label: "Loading", active: true }
      : { label: classData.title, active: true, translate: false },
  ];

  const [timeStamps, setTimeStamps] = useState([]);

  const fetchTimeStamps = async () => {
    setLoadingTimeStamp(true);
    try {
      const response = await getAllTimeStamps(params.id, "class", limit, currentPage);
      console.log("Response Timmepepp", response?.data?.pagination)
      setTimeStamps(response.data.data || []);
      setTotalPages(response?.data?.pagination?.totalPages);
      setLoadingTimeStamp(false);
      // console.log("Time Stamps", response.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setLoadingTimeStamp(false);
    }
  };

  const handleDeleteStudent = async (studentId) => {
    const toastId = toast.loading("Deleting student...");
    try {
      await deleteStudent(studentId);
      toast.update(toastId, {
        render: "Student deleted successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      // Refresh the student list after deletion
      fetchUsers();
    } catch (error) {
      console.error("Error deleting student:", error);
      toast.update(toastId, {
        render: "Error deleting student",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const fetchUsers = async () => {
    setLoadingStudents(true);
    const userType = "student";
    try {
      const response = await getClassTeachersAndStudents(params.id, userType, currentPageStudents, limitStudents);
      setStudents(response.data.results.members || []);
      setTotalPagesStudents(response?.data?.results?.pagination?.totalPages)
      // console.log("res",response.data.results)
    } catch (error) {
      console.error("Error fetching users:", error);
      setStudents([]);
    } finally {
      setLoadingStudents(false);
    }
  };

  const handleStatusChange = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      await UpdateStudentStatus(userId, newStatus);
      fetchUsers();
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  const fetchClass = async () => {
    setLoading(true);
    try {
      const response = await getClassDetail(params.id);
      setClassData(response?.data?.result || []);
    } catch (error) {
      console.error("Error fetching users:", error);
      setClassData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchTeachers = async () => {
    const userType = "teacher";
    setLoadingTeacher(true);
    try {
      const response = await getClassTeachersAndStudents(params.id, userType, currentPageTeacher, limitTeacher);
      setTeachers(response.data.results.members || []);
      setTotalPageTeacher(response?.data?.results?.pagination?.totalPages)
      // console.log("response.data", response.data.results)
    } catch (error) {
      console.error("Error fetching users:", error);
      setTeachers([]);
    } finally {
      setLoadingTeacher(false);
    }
  };
  const fetchAssignments = async (page = 1, subject = "", sort = "", search = "") => {
    const type = "class";
    setLoading(true);
    try {
      const response = await getSpecificSubmissions(params.id, type, currentPageTable, limitTable, subject, sort, search);
      console.log("Exercise Result", response?.data)
      setExercise(response.data.results.assignments || []);
      setTotalPagesTable(response?.data?.results?.pagination?.totalPages)
      setCurrentPage(page);
      setCurrentPageTable(page);
      setSelectedSubject(subject);
      setSelectedSort(sort);
      setSearch(search)
    } catch (error) {
      console.error("Error fetching users:", error);
      setTeachers([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchStats = async () => {
    try {
      const statsResponse = await getClassStats();
      console.log("Stats resonse Class", statsResponse?.data?.result)
      const statsData = await statsResponse?.data?.result;
      setStatsData(statsData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingStats(false);
    }
  };

  const fetchSubject = async () => {
    try {
      const response = await getAllSubject();
      const formattedSubjects = response?.data?.results?.subject?.map(subject => ({
        value: subject._id,
        label: subject.title,

      }));
      setSubjects(formattedSubjects);
    } catch (error) {
      console.error("Error fetching school details:", error);
    }
  };

  useEffect(() => {
    fetchClass();
    fetchStats();
    fetchSubject();
    fetchAssignments();
  }, []);
  useEffect(() => {
    fetchTimeStamps();
  }, [currentPage, limit]);
  useEffect(() => {
    fetchUsers();
  }, [currentPageStudents, limitStudents]);
  useEffect(() => {
    fetchTeachers();
  }, [currentPageTeacher, limitTeacher]);

  useEffect(() => {
    if (classData?.title) {
      setClassNameInput(classData.title);
    }
  }, [classData]);
  const getLevelBackgroundColor = (level) => {
    switch (level) {
      case "Elementary":
        return "#C4C4C4";
      case "Intermediate":
        return "#4DA9F4";
      case "Beginner":
        return "#0FE133";
      case "Advanced":
        return "#EB3232";
      case "Expert":
        return "#408c40";
      default:
        return "#B0BEC5";
    }
  };
  const handlePageChange = (page) => {
    fetchAssignments(page, selectedSubject, selectedSort, search)
  };

  const handlePageChangeStudents = (page) => {
    setCurrentPageStudents(page);
  };
  const handlePageChangeTeacher = (page) => {
    setCurrentPageTeacher(page);
  };
  const handleViewSubmissions = (assignment) => {
    navigate(
      assignment?.type === "exercise"
        ? `/assignments/submissions/view-all/${assignment._id}`
        : `/assignments/submissions/vocabulary/${assignment._id}`
    );
  };
  return (
    <>
      <BreadCrumbs items={breadcrumbItems} />
      {loading || !classData ? (
        <div className="my-2 ">
          <Placeholder className="" as="p" animation="glow">
            <Placeholder xs={3} />
          </Placeholder>
          <Placeholder className="" as="p" animation="glow">
            <Placeholder xs={4} />
          </Placeholder>
          <hr />
        </div>
      ) : (
        <div className="my-2 gap-2 d-flex align-items-center">
          {classNameField ? <input placeholder="Enter Class Name" className="mt-2" type="text" value={classNameInput} onChange={(e) => setClassNameInput(e.target.value)} /> : <PageHeading heading={classData?.title} />}
          {classNameField ? <Button onClick={handleClassNameChange} style={{ width: "75px", height: "35px" }} className="button-style mt-2 border-0 px-3 py-0 d-flex align-items-center justify-content-center gap-1" variant="danger">Save</Button>
            : <Button onClick={toggleClassName} style={{ width: "75px", height: "35px" }} className="button-style mt-2 border-0 px-3 py-0 d-flex align-items-center justify-content-center gap-1" variant="danger">Edit<CiEdit /></Button>
          }

          <hr />
        </div>
      )}

      <Statistics statsData={statsData} loadingstats={loadingstats} />
      <div>
        <Row>
          <Col xs={12}>
            <LatestActivities timeStamps={timeStamps} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} loadingTimeStamp={loadingTimeStamp} />
          </Col>
        </Row>
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between">
          <PageHeading heading={"Students"} />
          <div>
            {classData?.type === "class" ? (
              <Dropdown>
                <Dropdown.Toggle
                  className="button-style border-0 px-3 d-flex align-items-center justify-content-center gap-1"
                  variant="success"
                  id="dropdown-basic"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Add Students</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setShowModal(true)}>
                    Add Single
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleOpenImportSheetModal}>
                    Import Sheet
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button
                className="button-style border-0 px-3 d-flex align-items-center justify-content-center gap-1"
                variant="success"
                id="dropdown-basic"
                onClick={() => setShowGroupModal(true)}
              >
                <FontAwesomeIcon icon={faPlus} />
                <span>Add Students</span>
              </Button>
            )}
          </div>
        </div>
        <EntityTable
          loading={loadingStudents}
          loadingRows={limitStudents}
          items={students}
          emptyLabel={t("No Students in the class yet.")}
          onRowClick={(s) => navigate(`students/${s._id}`)}
          columns={[
            personNameColumn(t),
            emailColumn(t),
            phoneColumn(t),
            statusColumn(t),
            {
              key: "actions",
              label: "Actions",
              thClassName: "py-3 pe-3 fw-semibold text-end",
              className: "py-3 pe-3 text-end",
              // The card view had an active/inactive toggle; keep that here.
              stopRowClick: true,
              skeleton: <Skeleton width={70} />,
              render: (s) => (
                <Button
                  size="sm"
                  variant={s?.status === "active" ? "outline-secondary" : "outline-success"}
                  onClick={() => handleStatusChange(s?._id, s?.status)}
                >
                  {s?.status === "active" ? t("Deactivate") : t("Activate")}
                </Button>
              ),
            },
          ]}
        />
        <Row>
          <Col xs={12} className="d-flex justify-content-end my-3">
            <CustomPagination
              currentPage={currentPageStudents}
              totalPages={totalPagesStudents}
              onPageChange={handlePageChangeStudents}
            />
          </Col>
        </Row>
      </div>
      <div>
        <div className="d-flex align-items-center justify-content-between">
          <PageHeading heading={"Teachers"} />
          <div>
            <Button
              className="button-style border-0 px-3 d-flex align-items-center justify-content-center gap-1"
              variant="success"
              id="dropdown-basic"
              onClick={() => setShowTeacherModal(true)}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>Add Teachers</span>
            </Button>
          </div>
        </div>
        <EntityTable
          loading={loadingTeacher}
          loadingRows={limitTeacher}
          items={teachers}
          emptyLabel={t("No teachers in this class yet.")}
          onRowClick={(x) => navigate(`teachers/${x._id}`)}
          columns={[
            personNameColumn(t),
            emailColumn(t),
            phoneColumn(t),
          ]}
        />
        <Row>
          <Col xs={12} className="d-flex justify-content-end my-3">
            <CustomPagination
              currentPage={currentPageTeacher}
              totalPages={totalPageTeacher}
              onPageChange={handlePageChangeTeacher}
            />
          </Col>
        </Row>
      </div>
      <div>
        <div className="d-flex flex-column flex-lg-row gap-6 justify-content-between" style={{ gridGap: "20px" }}>
          <div style={{ display: "flex", alignItems: "center", gridGap: "10px", flexWrap: "wrap" }}>
            {/* Type Filter */}
            <Dropdown >

              <Dropdown.Toggle variant="light" id="dropdown-exercise" style={{ border: "1px solid rgb(185, 185, 185)", textTransform: "capitalize", color: "#323232", backgroundColor: "transparent", borderRadius: "30px", padding: "7px 20px", fontWeight: "500" }}>
                {selectedSubject || "Filter Language"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => { setSelectedSubject("All"); fetchAssignments(1, "All", selectedSort, search); }} style={{ textTransform: "capitalize" }}>{"All"}</Dropdown.Item>
                {subjects?.map((item, index) => (
                  <Dropdown.Item key={index} onClick={() => { setSelectedSubject(item?.label); fetchAssignments(1, item?.label, selectedSort, search); }} style={{ textTransform: "capitalize" }}>{item?.label}</Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Sort Filter */}
            <Dropdown>
              <Dropdown.Toggle variant="light" id="dropdown-exercise" style={{ border: "1px solid rgb(185, 185, 185)", textTransform: "capitalize", color: "#323232", backgroundColor: "transparent", borderRadius: "30px", padding: "7px 20px", fontWeight: "500" }}>
                {selectedSort || "Select Sort"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {sortOptions?.map((item, index) => (
                  <Dropdown.Item key={index} onClick={() => { setSelectedSort(item); fetchAssignments(1, selectedSubject, item, search); }}>{item}</Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <InputGroup>
                <Form.Control
                  type={"text"}
                  placeholder="Search Here..."
                  className="px-3 py-2 border-right-0"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent default form behavior
                      fetchAssignments(1, "", "", "", search); // Call your function
                    }
                  }}
                  style={{
                    borderTopLeftRadius: "30px",
                    borderBottomLeftRadius: "30px",
                    borderColor: "#ea4f50",
                    borderRight: "0",
                  }}
                />
                <InputGroup.Text
                  id="basic-addon2"
                  className="bg-white "
                  onClick={() => fetchAssignments(1, "", "", search)}
                  style={{
                    cursor: "pointer",
                    borderTopRightRadius: "30px",
                    borderBottomRightRadius: "30px",
                    borderColor: "#ea4f50",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSearch}
                    style={{ color: "#ea4f50" }}
                  />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </div>
        </div>
        <div className="mt-4">
          <Table responsive="sm" style={{ overflow: "auto" }}>
            <thead>
              <tr>
                <th style={{ color: "#303972" }}>Assignment Name</th>
                <th style={{ color: "#303972" }}>Subject</th>
                <th style={{ color: "#303972" }}>Deadline</th>
                {/* <th style={{ color: "#303972" }}>Status</th> */}
                <th style={{ color: "#303972" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                [...Array(4)].map((_, index) => (
                  <tr key={index}>
                    <td className="py-3">
                      <div
                        style={{
                          backgroundColor: "#e0e0e0",
                          height: "20px",
                          width: "80%",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </td>
                    <td className="py-3">
                      <div
                        style={{
                          backgroundColor: "#e0e0e0",
                          height: "20px",
                          width: "40%",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </td>
                    <td className="py-3">
                      <div
                        style={{
                          backgroundColor: "#e0e0e0",
                          height: "20px",
                          width: "40%",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </td>
                    <td className="py-3">
                      <div
                        style={{
                          backgroundColor: "#e0e0e0",
                          height: "20px",
                          width: "40%",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </td>
                    <td className="py-3">
                      <div
                        style={{
                          backgroundColor: "#e0e0e0",
                          height: "20px",
                          width: "40%",
                          borderRadius: "4px",
                        }}
                      ></div>
                    </td>
                  </tr>
                ))
              ) : exercises.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-3">
                    <Image src={nodataimage} />
                    <h5 className="mt-2 text-secondary">
                      No Assignments found
                    </h5>
                  </td>
                </tr>
              ) : (
                exercises.map((exercise, index) => (
                  <tr key={exercise._id}>
                    <td className="py-3">
                      <div
                        //   to={`attempt/${exercise?.exercise?._id}`}
                        style={{
                          color: "#303972",
                          fontWeight: 700,
                          textDecoration: "none",
                        }}
                      >
                        {exercise.title}
                      </div>
                    </td>
                    <td className="py-3" style={{ color: "#A098AE" }}>
                      {exercise?.exercise?.subject?.title}
                    </td>
                    <td className="py-3" style={{ color: "#A098AE" }}>
                      {moment(exercise?.endDate).format("MMM D, YYYY")}
                    </td>
                    {/* <td className="py-3" style={{ color: "#A098AE" }}>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "3px 10px",
                          borderRadius: "30px",
                          backgroundColor: getLevelBackgroundColor(
                            exercise?.submissionStatus
                          ),
                          color: "#fff",
                          fontSize: "14px",
                        }}
                      >
                        {exercise?.submissionStatus?.toUpperCase()}
                      </span>
                    </td> */}

                    <td className="py-3" style={{ color: "#A098AE" }}>
                      <Dropdown>
                        <Dropdown.Toggle
                          className="more bg-transparent text-black border-0 e-caret-hide rounded-0"
                          id="dropdown-basic"
                        >
                          <Card.Img
                            style={{ width: "24px", height: "24px" }}
                            variant="top"
                            src={dropdown}
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className="border-0"
                          style={{
                            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                          }}
                        >
                          <Dropdown.Item
                            style={{ color: "black" }}
                            onClick={() => handleViewSubmissions(exercise)}
                          >
                            <FontAwesomeIcon
                              icon={faFile}
                              style={{ fontSize: "15px" }}
                              size="20"
                              className="me-2"
                            />
                            All Submissions
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() =>
                              navigate(
                                `/exercise/my-exercises/${exercise.exercise._id}`
                              )
                            }
                            style={{ color: "black" }}
                          >
                            <FontAwesomeIcon
                              style={{ fontSize: "15px" }}
                              icon={faEye}
                              size="20"
                              className="me-1"
                            />
                            Show Exercise
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="text-danger"
                            onClick={() => handleShowDeleteModal(exercise._id)}
                          >
                            <FontAwesomeIcon
                              style={{ fontSize: "15px" }}
                              icon={faTrash}
                              className="me-2"
                            />
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          <Row>
            <Col xs={12} className="d-flex justify-content-end mt-3">
              <CustomPagination
                currentPage={currentPageTable}
                totalPages={totalPagesTable}
                onPageChange={handlePageChange}
              />
            </Col>
          </Row>
        </div>
      </div>
      <AddStudentModal
        show={showModal}
        handleClose={handleClose}
        fetchUsers={fetchUsers}
        classId={classData?._id}
      />

      <AddClassTeacherModal
        show={showTeacherModal}
        handleClose={handleTeacherClose}
        fetchUsers={fetchTeachers}
        classId={classData?._id}
      />
      <ImportSheetModal
        show={showImportSheetModal}
        handleClose={handleCloseImportSheetModal}
        fetchUsers={fetchUsers}
        classId={classData?._id}
        handleShowCredentials={handleShowSummaryModal}
        setSummaryData={setSummaryData}
      />
      <SummaryModal
        show={showSummaryModal}
        handleClose={handleCloseSummaryModal}
        summary={summaryData}
      />
      <AddGroupStudentsModal
        show={showGroupModal}
        groupId={params?.id || classData?._id}
        handleClose={handleCloseModal}
        fetchClasses={fetchUsers}
      />
      <DeleteAssignmentModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleConfirmDelete={() => handleDeleteExercise(pendingStatusChange.id)}
      />
    </>
  );
};

export default ClassesAndGroupDetailPage;
